import {
  Dialog,
  DialogContent,
  Slide,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Authentication from "./components/Authentication";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import useAuth from "./hook/auth";
import * as send from "../lib/analytics/send";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BOT_USER_AGENTS = [
  "googlebot",
  "bingbot",
  "slurp",
  "duckduckbot",
  "yandexbot",
  "facebot",
  "applebot",
];

const IS_BOT =
  typeof window !== "undefined" &&
  BOT_USER_AGENTS.some((bot) =>
    navigator.userAgent.toLowerCase().includes(bot)
  );

function parseCustomAttributes(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function needPremium(Component) {
  function NeedPremium(props) {
    const auth = useAuth();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const { user } = auth || {};
    const { reloadUserInfo } = user || {};
    const customAttributes = reloadUserInfo?.customAttributes;

    const [open, setOpen] = useState(false);
    const [comp, setComp] = useState("");

    const isPremium = useMemo(() => {
      if (IS_BOT) return true;
      const parsed = parseCustomAttributes(customAttributes);
      return (
        parsed?.userType === "PREMIUM" || parsed?.userType === "PROFESSIONAL"
      );
    }, [customAttributes]);

    const handleDialogOpen = useCallback(
      (event, component) => {
        setOpen(true);
        setComp(component);
        send.uevent(
          event,
          `${user ? `${component}-pricing` : `${component}-login`}-banner-open`
        );
      },
      [user]
    );

    const handleDialogClose = useCallback(
      (e) => {
        setOpen(false);
        e?.preventDefault();
        send.uevent(
          e,
          `${user ? `${comp}-pricing` : `${comp}-login`}-banner-close`
        );
      },
      [user, comp]
    );

    useEffect(() => {
      setOpen(false);
    }, [user]);

    return (
      <>
        <Component
          auth={auth}
          showPricingBanner={handleDialogOpen}
          isPremium={isPremium}
          {...props}
        />
        <Dialog
          onClose={handleDialogClose}
          open={open}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="auth-dialog"
          aria-label="Authentication"
          maxWidth="md"
          sx={{
            "& .MuiGrid-root": user
              ? {
                  m: "0 !important",
                  p: "0 !important",
                  flexBasis: "100% !important",
                  maxWidth: "100% !important",
                }
              : {},
            "& .MuiDialog-paper": {
              maxHeight: "calc(100% - 64px)",
              width: "94% !important",
              transition: "max-height 2s ease-in-out",
              p: "0 !important",
              m: "0 !important",
              boxShadow: 0,
              textAlign: "center",
              borderRadius: "8px",
            },
            "& .MuiDialogContent-root": { p: "0 !important" },
            "& .MuiBackdrop-root": {
              backdropFilter: "blur(3px)",
            },
            borderRadius: "8px",
          }}
        >
          <IconButton
            size="small"
            aria-label="Close dialog"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              zIndex: 2,
              right: 8,
              top: 8,
              "&:hover": {
                color: "#2a2d64",
              },
            }}
          >
            <CancelRoundedIcon fontSize="small" />
          </IconButton>
          <DialogContent sx={{ p: isMobile ? 0 : "" }}>
            <Authentication
              maxWidth={10}
              isPopup={true}
              comp={comp}
              user={user}
              {...props}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  }

  NeedPremium.displayName = `NeedPremium(${
    Component.displayName || Component.name || "Component"
  })`;

  return NeedPremium;
}